function parseDate(date) {
    var dateParts = date.split("-");
    return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
}

function format(dates) {
    var fart = formatDate(dates[0])
    if (dates.length > 1) {
        fart = fart + " - " + formatDate(dates[1]);
    }
    return fart
}

function formatDate(date) {
    if (!(date instanceof Date)) {
        date = new Date();
    }
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();

    return yyyy + '/' + mm + '/' + dd;

}

function formatTime(date) {
    var hh = String(date.getHours()).padStart(2, '0');
    var mm = String(date.getMinutes()).padStart(2, '0');
    var ss = String(date.getSeconds()).padStart(2, '0');
    return hh + ':' + mm + ':' + ss;
}
export { parseDate, format, formatDate, formatTime };
